import ComponentLabrator from "Components/Labrator/Index";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Labrator = (props: any) => {
  const { id } = useParams();
  useEffect(() => {
  }, [id])

  return (
    <>
      <ComponentLabrator table={'spring'} table_id={id}/>
    </>
  )
}


export default Labrator;